import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import GlassCard from "../dashboard/GlassCard";
import DataModeBadge from "./DataModeBadge";
import RiskBadge from "./RiskBadge";
import { useTranslation } from "react-i18next";

const RiskScoreCard = ({ item }) => {
  const { t } = useTranslation();
  const score = Number(item.score || 0);
  return (
    <GlassCard hover={false} sx={{ height: "100%" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Box>
          <Typography variant="h5">{item.scope}</Typography>
          <Typography variant="body2" color="text.secondary">{t("platform.risk.scoreAndDrivers")}</Typography>
        </Box>
        <RiskBadge score={score} />
      </Stack>
      <Box display="flex" alignItems="baseline" gap={1} mt={2}>
        <Typography variant="h2">{score}</Typography>
        <Typography variant="body2" color="text.secondary">{t("platform.risk.outOf100")}</Typography>
        {item.trend && <Typography variant="caption" color={String(item.trend).startsWith("+") ? "error.main" : "success.main"}>{item.trend}</Typography>}
      </Box>
      <LinearProgress value={score} variant="determinate" color={score >= 75 ? "error" : score >= 55 ? "warning" : "success"} sx={{ height: 8, borderRadius: "8px", my: 2 }} />
      <Stack spacing={0.75}>
        {(item.factors || []).slice(0, 3).map((factor) => (
          <Typography key={factor} variant="body2" color="text.secondary">{factor}</Typography>
        ))}
      </Stack>
      <Box mt={2}><DataModeBadge mode={item.dataMode || "mock"} /></Box>
    </GlassCard>
  );
};

export default RiskScoreCard;
